import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Typography, Button} from "@material-ui/core";
import {IPointCoords, INotificacion, IParcela, ISections} from "../../../types";
import {parseNameParcela} from "../../../tools/ParseNameParcela";
import config from "../../../config.json";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {getCenterZoom} from "../../../tools/getCenterZoom";
import {LatLngTuple} from "leaflet";

const texts = require('../../../texts/configuracion.json');


interface IProps {
    notify(notification: INotificacion): void
    Cargando(cargando: boolean): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setParcela(parcela: string): void
    setRiego(riego: Record<string, Record<string, number>>): void
    setPronostico(pronostico: Record<string, Record<string, number>>): void
    setElTiempoLatLon(elTiempoLatLon: IPointCoords): void
    selectSection(section: ISections) :void
    parcelas: IParcela[]
    usuario: string
    parcela: string
    idioma: string
}

interface IState {
    text: Record<string, string>
}

class ConfigParcelas extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    IdNombreParcela = ():Record<string, string>[] => {
        const id2name: Record<string, string>[] = []
        for (const parcela of this.props.parcelas) {
            if (parcela.eliminada === 1) continue
            if (!parcela.propietario.split(',').includes(this.props.usuario)) continue
            id2name.push({
                id: parcela.id,
                nombre: parcela.nombre
            })
        }
        return id2name
    }

    onTagsChange = async (id: string) => {
        for (const parcela of this.props.parcelas) {
            if (parcela.id === id ) {
                this.props.setParcela(id)
                const center = getCenterZoom(parcela.lat_lon).center
                this.props.setZoom(17)
                this.props.setCenter(center)
                this.props.setElTiempoLatLon({
                    lat: center[0],
                    lon: center[1]
                })
            }
        }
    }

    selectParcela = (parcela: string) => {
        if (parcela === this.props.parcela) {
            this.props.selectSection('caracterizacion')
            return
        }

        this.onTagsChange(parcela)

        const url: string = config.url+`/calcula/riego?parcela=${parcela}`
        this.props.Cargando(true)
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.props.setRiego(res.data)
                let fecha = (new Date).toISOString().split('T')[0].split('-').join('_')
                this.props.selectSection('caracterizacion')
                axios.get(
                    config.url+`/static/visualizador/pronostico_tiempo/${parcela}/${fecha}.json`,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.Cargando(false)
                        this.props.setPronostico(res.data)
                    })
                    .catch(() => {
                        this.props.Cargando(false)
                        // this.props.notify({message: this.state.text["22"], variant: 'error'})
                    })
            })
            .catch(() => {
                // this.props.notify({message: this.state.text["22"], variant: 'error'})
                this.props.Cargando(false)
            })
    }


    render () {
        const options = this.IdNombreParcela()
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%',
                    marginLeft: 20
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                {options.map(element =>
                    <Button
                        key={element.id}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 20,
                            width: "fit-content"
                        }}
                        onClick={() => this.selectParcela(element.id)}
                    >
                        <Typography
                            style={{
                                fontSize: 18,
                                fontWeight: "bold",
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                margin: 5
                            }}
                        >
                            {parseNameParcela(element.nombre)}
                        </Typography>
                    </Button>
                )}

            </div>
        )
    }

}

const mapStateToProps = (state: IStore) => ({
    parcelas: state.principal.parcelas,
    usuario: state.principal.usuario,
    parcela: state.navegacion.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    Cargando: (cargando: boolean) => dispatch({type: "cargando", cargando}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setParcela: (parcela: string) => dispatch({type: "set-parcela", parcela}),
    setRiego: (riego: Record<string, Record<string, number>>) => dispatch({type: "set-riego-riego", riego}),
    setPronostico: (pronostico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-pronostico", pronostico}),
    setElTiempoLatLon: (elTiempoLatLon: IPointCoords) => dispatch({type: "set-eltiempo_latlon", elTiempoLatLon}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section})
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfigParcelas);
